import React, { useState, useEffect } from 'react';
import '../../../css/Transparencia/ejecucion-presupuestaria.css';

const ANIOS = [2026, 2025, 2024, 2023, 2022, 2021, 2020];
const MESES = [
  "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"
];

const urlPDF = (anio, mes) =>
  `http://ciudaddeoliva.gov.ar/file/pdf/balance/ep-${anio}-${mes}.pdf`;

const EjecucionPresupuestaria = () => {
  const [abierto, setAbierto] = useState(ANIOS[0]);
  const hoy = new Date();
  const [mesActualDisponible, setMesActualDisponible] = useState(true);

  useEffect(() => {
    // Solo chequea el mes actual del año actual
    const anio = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    if (ANIOS.includes(anio)) {
      fetch(urlPDF(anio, mes), { method: "HEAD" })
        .then(res => setMesActualDisponible(res.ok))
        .catch(() => setMesActualDisponible(false));
    }
  }, []);

  return (
    <div className="ejecucion-container">
      <div className="ejecucion-header">
        <h2>EJECUCIÓN PRESUPUESTARIA</h2>
      </div>
      <div className="ejecucion-descripcion">
        <h2>
          En esta sección encontrará los Balances Municipales de cada período, aprobados por el Tribunal de Cuentas, para que cada vecino pueda ejercer su derecho de revisión de los movimientos económicos de la Municipalidad.
        </h2>
      </div>
      <div className="ejecucion-balances">
        <h3>Balances Municipales</h3>
        {ANIOS.map(anio => (
          <div key={anio} className="balance-anio">
            <button
              className="btn-prs"
              onClick={() => setAbierto(abierto === anio ? null : anio)}
            >
              Ejecución Presupuestaria {anio}
            </button>
            {abierto === anio && (
              <div className="balance-meses">
                <div className="balance-header">
                  <div>PERIODO</div>
                  <div>Ingresos / Egresos</div>
                </div>
                {MESES.filter(mes => {
                  if (anio === hoy.getFullYear()) {
                    const mesNum = parseInt(mes, 10);
                    const mesActual = hoy.getMonth() + 1;
                    if (mesNum < mesActual) return true;
                    if (mesNum === mesActual) return mesActualDisponible;
                    return false;
                  }
                  return true;
                }).map(mes => (
                  <div className="balance-row" key={mes}>
                    <div>{mes}/{anio}</div>
                    <div>
                      <a
                        href={urlPDF(anio, mes)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ingresos Egresos
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EjecucionPresupuestaria;
